module.exports = __webpack_public_path__ + "static/WEDDING E&M-291-4908045874991e1270c592eda9df2ee9.jpg";